import CounselorProfileModel from './CounselorProfileModel';

export default class CounselorGroupSessionModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.topic = data.topic || '';
    this.type = data.type || ''; // this model is used for events + sessions

    this.user_limit = data.user_limit || 0;
    this.users_currently_attending = data.users_currently_attending || 0;

    this.start_time = data.start_time ? new Date(data.start_time) : null;
    this.end_time = data.end_time ? new Date(data.end_time) : null;

    this.am_attending = data.am_attending || false;

    this.counselor = data.counselor ? new CounselorProfileModel(data.counselor) : null;

    this.cost = data.session_price || data.price || data.cost || 0;

    this.meeting_start_url = data.meeting_start_url || data.meeting_join_url || '';
    this.is_meeting_host = data.meeting_start_url && data.meeting_start_url.length > 0;
    this.struggle_areas = data.struggle_areas || [];
    this.description = data.description || '';

    this.attendees = data.attendees || [];

    this.host = data.host || null; // {first_name, last_name, photo}

    this.in_person = data.in_person || false;
    this.in_person_location = data.in_person_location || '';
  }

  isMine(id) {
    return (this.host && this.host.id === id) ||
      (this.counselor && this.counselor.id === id);
  }

  get joined() {
    return this.am_attending;
  }

  get num_spots_left() {
    if (this.user_limit) {
      return this.user_limit - this.users_currently_attending;
    }
    return null;
  }

  get canJoin() {
    return !this.user_limit || this.num_spots_left > 0;
  }

  get endsOnDifferentDay() {
    if (this.start_time && this.end_time) {
      return this.start_time.getFullYear() !== this.end_time.getFullYear() ||
        this.start_time.getMonth() !== this.end_time.getMonth() ||
        this.start_time.getDate() !== this.end_time.getDate();
    }
    return false;
  }
}
